import { render, staticRenderFns } from "./PurchaseContract.vue?vue&type=template&id=526a7344&scoped=true&"
import script from "./PurchaseContract.vue?vue&type=script&lang=js&"
export * from "./PurchaseContract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "526a7344",
  null
  
)

export default component.exports